import { render, staticRenderFns } from "./copyinput.vue?vue&type=template&id=7f2db7d0&"
import script from "./copyinput.vue?vue&type=script&lang=js&"
export * from "./copyinput.vue?vue&type=script&lang=js&"
import style0 from "./copyinput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2db7d0')) {
      api.createRecord('7f2db7d0', component.options)
    } else {
      api.reload('7f2db7d0', component.options)
    }
    module.hot.accept("./copyinput.vue?vue&type=template&id=7f2db7d0&", function () {
      api.rerender('7f2db7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/form-fields/copyinput.vue"
export default component.exports